import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

interface ReviewSectionProps {
  currentLang: string;
}

export default function ReviewSection({ currentLang }: ReviewSectionProps) {
  const { t } = useTranslation('home');

  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full px-4 sm:px-6 lg:px-10 xl:px-16 max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
          <div className="relative rounded-xl overflow-hidden aspect-[4/3] lg:aspect-[5/4] order-2 lg:order-1">
            <img
              src="https://readdy.ai/api/search-image?query=Person%20browsing%20customer%20reviews%20with%20star%20ratings%20displayed%20on%20a%20laptop%20screen%20in%20a%20cozy%20coffee%20shop%20warm%20ambient%20lighting%20lifestyle%20editorial%20photography%20high%20detail%20authentic%20scene&width=800&height=600&seq=review-img-001&orientation=landscape&nocache=true"
              alt="AllChinaBuy Review"
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-foreground-900/5 to-transparent" />
          </div>
          <div className="order-1 lg:order-2">
            <span className="text-secondary-500 text-xs font-semibold uppercase tracking-[0.15em] mb-3 block">
              Review
            </span>
            <h2 className="font-heading text-2xl md:text-3xl lg:text-4xl font-semibold text-foreground-900 leading-snug mb-5">
              {t('review_h2')}
            </h2>
            <p className="text-foreground-600 text-base md:text-lg leading-relaxed mb-6">
              {t('review_copy')}
            </p>
            <Link
              to={`/${currentLang}/review/`}
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 font-label font-semibold text-sm rounded-md hover:bg-primary-600 transition-colors"
            >
              {t('review_cta')}
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}